import Vue from 'vue';
import Router from 'vue-router';
import joinUpLargeScreen from '../page/joinUpLargeScreen';
import electricityUse from '../page/electricityUse';
import pointsHome from '../page/pointsHome';
import entering from '../page/pointsHome/entering';
import exchange from '../page/pointsHome/exchange';
import qrcodeReader from '../page/pointsHome/qrcodeReader';
import faceRecognition from '../page/pointsHome/faceRecognition';
import classStatistics from '../page/classStatistics/classStatistics';
import schoolProject from '../page/schoolProject/schoolProject';
import smartLinkBigScreen from '../page/smartLinkBigScreen/smartLinkBigScreen';
import smartCanteenScreen from '../page/smartCanteenScreen/smartCanteenScreen';
import evaluateScreen from '../page/evaluateScreen/evaluateScreen';
import securityScreen from '../page/securityScreen/securityScreen';

import billInquiry from '../page/billManage/billInquiry';
import studentBill from '../page/billManage/studentBill';
import studentBillDetail from '../page/billManage/studentBillDetail';
import studentBillDetailWx from '../page/billManage/studentBillDetailWx';
import billPaySuccess from '../page/billManage/billPaySuccess';

import bigScreenCar from '../page/bigScreenCar/index';
// import videoCall from '../page/videoCall/index';

//金穗护工
import caregiverIndex from '../page/caregiver/caregiverIndex';
import orderConfirm from '../page/caregiver/orderConfirm';
import patientList from '../page/caregiver/patientList';
import patientForm from '../page/caregiver/patientForm';
import agreement from '../page/caregiver/agreement';
import signature from '../page/caregiver/signature';
import order from '../page/caregiver/order';
import orderDetail from '../page/caregiver/orderDetail';
import orderDetailProgress from '../page/caregiver/orderDetailProgress';
import my from '../page/caregiver/my';
import privacy from '../page/caregiver/privacy';

import screen from '../page/screen/screen';

Vue.use(Router);
const routers = new Router({
    routes: [
        { //智能接入中心
            path: '/joinUpLargeScreen',
            name: 'joinUpLargeScreen',
            component: joinUpLargeScreen,
        },
        {//水电使用
            path: '/electricityUse',
            name: 'electricityUse',
            component: electricityUse,
        },
        /**
         * 综合评价
         * */
        { //积分首页
            path: '/pointsHome',
            name: 'pointsHome',
            component: pointsHome,
        },
        { //积分卡录入
            path: '/entering',
            name: 'entering',
            component: entering,
        },
        { //综评道具兑换
            path: '/exchange',
            name: 'exchange',
            component: exchange,
        },
        {
            path: '/qrcodeReader',
            name: 'qrcodeReader',
            component: qrcodeReader,
        },
        { //人脸识别
            path: '/faceRecognition',
            name: 'faceRecognition',
            component: faceRecognition,
        },
        // 班级统计
        {
            path: '/classStatistics',
            name: 'classStatistics',
            component: classStatistics,
        },
        // 微+项目
        {
            path: '/schoolProject',
            name: 'schoolProject',
            component: schoolProject,
        },

        //校园智连数据大屏
        {
            path: '/smartLinkBigScreen',
            name: 'smartLinkBigScreen',
            component: smartLinkBigScreen,
        },
        //智慧食堂就餐大屏
        {
            path: '/smartCanteenScreen',
            name: 'smartCanteenScreen',
            component: smartCanteenScreen,
        },
        //综合评价大屏
        {
            path: '/evaluateScreen',
            name: 'evaluateScreen',
            component: evaluateScreen,
        },
        //安防大屏
        {
            path: '/securityScreen',
            name: 'securityScreen',
            component: securityScreen,
        },

        //账单缴费
        {
            path: '/billInquiry',
            name: 'billInquiry',
            component: billInquiry,
            beforeEnter: (to, from, next) => {
                // document.title = '学杂费缴费系统，输入学生证件号获取学费账单，微信、支付宝扫一扫缴费';
                document.title = '学杂费缴费系统';
                next();
            }
        },
        {
            path: '/studentBill',
            name: 'studentBill',
            component: studentBill,
        },
        {
            path: '/studentBillDetail',
            name: 'studentBillDetail',
            component: studentBillDetail,
        },
        {
            path: '/studentBillDetailWx',
            name: 'studentBillDetailWx',
            component: studentBillDetailWx,
        },
        {
            path: '/billPaySuccess',
            name: 'billPaySuccess',
            component: billPaySuccess,
        },

        {
            path: '/bigScreenCar',
            name: 'bigScreenCar',
            component: bigScreenCar,
        },
        // { //视频通话
        //     path: '/videoCall',
        //     name: 'videoCall',
        //     component: videoCall,
        // },


        //金穗护工
        {
            path: '/caregiverIndex',
            name: 'caregiverIndex',
            component: caregiverIndex,
            beforeEnter: (to, from, next) => {
                document.title = '金穗护工';
                next();
            }
        },
        {
            path: '/orderConfirm',
            name: 'orderConfirm',
            component: orderConfirm,
        },
        {
            path: '/patientList',
            name: 'patientList',
            component: patientList,
        },
        {
            path: '/patientForm',
            name: 'patientForm',
            component: patientForm,
        },
        {
            path: '/agreement',
            name: 'agreement',
            component: agreement,
        },
        {
            path: '/signature',
            name: 'signature',
            component: signature,
        },
        {
            path: '/order',
            name: 'order',
            component: order,
        },
        {
            path: '/orderDetail',
            name: 'orderDetail',
            component: orderDetail,
        },

        {
            path: '/orderDetailProgress',
            name: 'orderDetailProgress',
            component: orderDetailProgress,
        },
        {
            path: '/my',
            name: 'my',
            component: my,
        },
        {
            path: '/privacy',
            name: 'privacy',
            component: privacy,
        },

        // 楼层宿管看板 特殊处理
        {
            path: '/screen',
            name: 'screen',
            component: screen,
        },
    ],
});

routers.beforeEach((to, from, next) => {
    next();
});

function filterrouters(path) {
    const paths = ['/'];
    return paths.includes(path);
}

export default routers;
